// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"4":"preflight","293":"kora-status","298":"oc-users","981":"in-app-numbers"}[chunkId] + "." + {"4":"7870ec78","293":"3d1a1099","298":"e0f3b603","981":"04d7f5cb"}[chunkId] + ".css";
};